<div class="modal-header">
  <h4 class="modal-title">Update currency pair</h4>
  <i class="fa fa-2x fa-times" (click)="modalRef.hide()"></i>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <label>Six letter code</label>
      <input type="text" class="form-control" formControlName="sixLetterCode" data-lpignore="true">
    </div>
    <div class="row">
      <label>Swap price factor</label>
      <input type="number" class="form-control" formControlName="swapPriceFactor" data-lpignore="true">
    </div>
    <div class="row">
      <label>Spot price factor</label>
      <input type="number" class="form-control" formControlName="spotPriceFactor" data-lpignore="true">
    </div>
    <div class="row">
      <label>Spot price precision</label>
      <input type="number" class="form-control" formControlName="spotPricePrecision" data-lpignore="true">
    </div>
    <div class="row">
      <label>Swap price precision</label>
      <input type="number" class="form-control" formControlName="swapPricePrecision" data-lpignore="true">
    </div>
    <div class="row">
      <label>Display spot price precision</label>
      <input type="number" class="form-control" formControlName="displaySpotPricePrecision" data-lpignore="true">
    </div>
    <div class="row">
      <label>Rounding</label>
      <input type="number" class="form-control" formControlName="rounding" data-lpignore="true">
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="modalRef.hide()">Cancel</button>
  <button type="submit" class="btn btn-primary" [disabled]="form.invalid" (click)="createEvent()">Create</button>
</div>
